import { computed, ref } from "vue";
const computedWithDelayedSetter = (initialValue, delay) => {
  const isDebouncing = ref(false);
  let internalValue = ref(initialValue);
  let internalTimeout = 0;

  const computedValue = computed({
    get: () => {
      console.log("get recalculated", internalValue.value)
      return internalValue.value;
    },
    // setter
    set: (incomingValue) => {
      console.log('hit set', incomingValue);
      isDebouncing.value = true;
      clearTimeout(internalTimeout);

      if (utilities.isSSR()) {
        isDebouncing.value = false;
        internalValue.value = incomingValue;
      } else {
        internalTimeout = setTimeout(() => {
          console.log('setting',incomingValue);
          isDebouncing.value = false;
          internalValue.value = incomingValue;
        }, delay);
      }
    },
  });

  const stopDebounce = () => {clearTimeout(internalTimeout);}
  return {
    computedValue,
    isDebouncing,
    stopDebounce,
  };
};

export default computedWithDelayedSetter;
